import { type TypedDocumentNode, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import type { PricingSheetCoreQuery, PricingSheetCoreQueryVariables } from 'types/graphql';

export const PRICING_SHEET_CORE_QUERY: TypedDocumentNode<PricingSheetCoreQuery, PricingSheetCoreQueryVariables> = gql`
  query PricingSheetCoreQuery($id: Int!) {
    pricingSheet(id: $id) {
      id
      draft
      enabled
      name
      customerGroups {
        id
        name
      }
      individualCustomers {
        id
        name
      }
      startDate
      expiryDate
      pricingFormula
      pricingValue
      roundingValue
    }
  }
`;

export type PricingSheetCore = NonNullable<PricingSheetCoreQuery['pricingSheet']>;

export default function usePricingSheet(id?: number): PricingSheetCore | undefined {
  const { data } = useQuery(PRICING_SHEET_CORE_QUERY, { variables: { id: id ?? 0 }, skip: !id });
  return useMemo(() => {
    if (!data?.pricingSheet) return undefined;
    return data.pricingSheet;
  }, [data?.pricingSheet]);
}
